import React, { useState, useEffect } from 'react'
import './Modal.scss'
import Input from '../Input'
import Button from '../Button'
import BaseModal from '../BaseModal'
import AutoComplete from '../AutoComplete'

/* eslint no-eval: 0 */
const CustomModal = ({ visible, color, title, titleImage, onClose, selectedCompany, selectedType, children, fields, btn1, btn2 }) => {

  const [companyRuc, setCompanyRuc] = useState('')
  const [companyName, setCompanyName] = useState('')
  const [dispatchWork, setDispatchWork] = useState('')
  const [dispatchType, setDispatchType] = useState('')
  const [dispatchPname, setDispatchPname] = useState("");

  useEffect(() => {
    if (selectedCompany) {
      setCompanyName(selectedCompany.name);
      setCompanyRuc(selectedCompany.ruc);
    }
    if (selectedType) {
      setDispatchWork(selectedType.work);
      setDispatchType(selectedType.type);
      if (selectedType.type === selectedType.pname) {
        setDispatchPname("");
      } else {
        setDispatchPname(selectedType.pname);
      }
    }
    // eslint-disable-next-line
  }, [visible]);

  useEffect(() => {
    const data =
      fields &&
      fields.reduce((obj, field) => {
        obj[field] = eval(field);
        return obj;
      }, {});
    console.log(data);
  });

  const checkDisabled = () => {
    return fields
      ? fields.some((field) => {
          if (field === "dispatchPname") {
            return false;
          } else {
            return !eval(field);
          }
        })
      : false;
  };

  const renderFields = () => {
    const rows = [];
    if (fields.includes("companyName")) {
      rows.push(
        <div key="companyName" className="modal-input">
          <Input
            key="companyName"
            placeholder="Nombre de la empresa"
            value={companyName}
            onChange={(text) => setCompanyName(text)}
            type="text"
          />
        </div>
      );
    }
    if (fields.includes("companyRuc")) {
      rows.push(
        <div key="companyRuc" className="modal-input">
          <Input
            key="companyRuc"
            placeholder="Número de RUC"
            value={companyRuc}
            onChange={(text) => setCompanyRuc(text)}
            type="text"
          />
        </div>
      );
    }
    if (fields.includes("dispatchWork")) {
      rows.push(
        <div key="dispatchRow" className="modal-grid">
          <div className="modal-input-container">
            <Input
              key="dispatchWork"
              // placeholder='Jornada BT'
              placeholder="Cód. BT"
              value={dispatchWork}
              onChange={(text) => setDispatchWork(text)}
              type="text"
            />
          </div>
          <div className="modal-input-container">
            <Input
              key="dispatchType"
              placeholder="Tipo de despacho"
              value={dispatchType}
              onChange={(text) => setDispatchType(text)}
              type="text"
            />
          </div>
          <div className="modal-input-container">
            <AutoComplete
              key="dispatchPname"
              placeholder="Jornada Padre (Opcional)"
              value={dispatchPname}
              onChange={(text) => setDispatchPname(text)}
              type="text"
            />
          </div>
        </div>
      );
    }
    return rows;
  };

  return (
    <BaseModal
      title={title}
      titleImage={titleImage}
      color={color}
      onClose={onClose}
      size="big"
      visible={visible}
    >
      <div className='modal-form-container'>
        {
          fields ? (
            <div className='modal-form-container-fields'>
              {renderFields()}
            </div>
          ) : children
        }
        {
          (btn1 || btn2) ? (
            <div className='modal-form-container-footer'>
              {btn1 && (
                <Button
                  text={btn1.text}
                  type={btn1.type}
                  color={color}
                  onClick={() => btn1.onClick()}
                />
                )}
              {btn2 && (
                <Button
                  text={btn2.text}
                  type={btn2.type}
                  disabled={checkDisabled()}
                  color={color}
                  onClick={() => {
                    const data = fields && fields.reduce((obj, field) => {
                      obj[field] = eval(field)
                      return obj
                    }, {})
                    btn2.onClick(data)
                  }}
                />
              )}
            </div>
          ) : null
        }
      </div>
    </BaseModal>
  )

}

export default CustomModal
